import { infer as Infer, z } from 'zod';

import { groupScheduleMeetingSchema, groupScheduleSchema } from './groupSchedule.schema';

export const groupCreateSchema = z.codec(
  z.object({
    name: z.string().min(1, 'Nazwa jest wymagana'),
    desc: z.string().nullable(),
    slots: z.number().nullable(),
    schedule: groupScheduleSchema.nullable(),
  }),
  z.object({
    name: z.string().min(1, 'Nazwa jest wymagana'),
    desc: z.string().nullable(),
    slots: z.number().nullable(),
    schedule: z
      .object({
        startDate: z.iso.date({ message: 'Data rozpoczęcia jest wymagana' }),
        endDate: z.iso.date({ message: 'Data zakończenia jest wymagana' }),
        meetings: z.array(groupScheduleMeetingSchema.out),
      })
      .nullable(),
  }),
  {
    decode: (group) => ({
      ...group,
      schedule: group.schedule
        ? {
            ...group.schedule,
            meetings: group.schedule.meetings.map((meeting) => groupScheduleMeetingSchema.decode(meeting)),
          }
        : group.schedule,
    }),
    encode: (group) => ({
      ...group,
      schedule: group.schedule
        ? {
            ...group.schedule,
            meetings: group.schedule.meetings.map((meeting) => groupScheduleMeetingSchema.encode(meeting)),
          }
        : group.schedule,
    }),
  }
);

export type GroupCreateSchema = Infer<typeof groupCreateSchema.in>;
export type GroupCreateSchemaInput = Infer<typeof groupCreateSchema.in>;
export type GroupCreateSchemaOutput = Infer<typeof groupCreateSchema.out>;
